var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskapprovalActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9583 2.34375H8.04167C7.17501 2.34375 6.46667 3.04375 6.46667 3.91042V4.69375C6.46667 5.56042 7.16667 6.26042 8.03334 6.26042H11.9583C12.825 6.26042 13.525 5.56042 13.525 4.69375V3.91042C13.5333 3.04375 12.825 2.34375 11.9583 2.34375Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3667 4.69268C14.3667 6.01768 13.2834 7.10101 11.9584 7.10101H8.0417C6.7167 7.10101 5.63337 6.01768 5.63337 4.69268C5.63337 4.22601 5.13337 3.93434 4.7167 4.15101C3.5417 4.77601 2.7417 6.01767 2.7417 7.44267V15.2843C2.7417 17.3343 4.4167 19.0093 6.4667 19.0093H13.5334C15.5834 19.0093 17.2584 17.3343 17.2584 15.2843V7.44267C17.2584 6.01767 16.4584 4.77601 15.2834 4.15101C14.8667 3.93434 14.3667 4.22601 14.3667 4.69268ZM12.7834 11.2843L9.45003 14.6177C9.32503 14.7427 9.1667 14.801 9.00837 14.801C8.85003 14.801 8.6917 14.7427 8.5667 14.6177L7.3167 13.3677C7.07503 13.126 7.07503 12.726 7.3167 12.4843C7.55837 12.2427 7.95837 12.2427 8.20003 12.4843L9.00837 13.2927L11.9 10.401C12.1417 10.1593 12.5417 10.1593 12.7834 10.401C13.025 10.6427 13.025 11.0427 12.7834 11.2843Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskapprovalActive);
export default __webpack_public_path__ + "static/media/taskapproval_active.3f134750a38e2a1ace63e832a775ef7d.svg";
export { ForwardRef as ReactComponent };